module.exports = __webpack_public_path__ + "img/two-panel-painting-of-palm-plant-1374125.bd63da04.jpg";